import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  withGoogleMap,
  GoogleMap,
  withScriptjs,
  Marker,
} from "react-google-maps";
import { setDefaults, OutputFormat } from "react-geocode";
import { mapStyles } from "../../utils/map";

// ✅ Setup Geocode defaults
setDefaults({
  key: process.env.REACT_APP_GOOGLEMAPS_API_KEY || "",
  language: "en",
  region: "es",
  outputFormat: OutputFormat.JSON,
});

const GoogleCustomMap = () => {
  const themeColor = "#34558b"; // replace with your theme color

  const storeInfo = useSelector((state: any) => state?.store?.selectedStore);
  // @@ store lat and long
  const latLong = useMemo(() => {
    const lat = storeInfo?.lattitude || "50.8258231";
    const lng = storeInfo?.longitude || "-1.214486";
    const storeName = storeInfo?.store_name || "";
    return { lat, lng, storeName };
  }, [storeInfo]);

  // @@ marker location
  const markerLocation = useMemo(() => {
    return {
      lat: Number(latLong?.lat),
      lng: Number(latLong?.lng),
    };
  }, [latLong]);

  const markerIcon = {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      width="40" 
      height="40"
      fill="${themeColor}" 
      stroke="white" 
      strokeWidth="2"
    >
      <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
      <circle cx="12" cy="9" r="2.5" fill="white"/>
    </svg>`)}`,
  };

  const GoogleMapAny = GoogleMap as any;

  const MapWithMarker = withScriptjs(
    withGoogleMap(({ onMapClick }: any) => (
      <GoogleMapAny
        defaultZoom={15}
        defaultCenter={{
          lat: markerLocation.lat,
          lng: markerLocation.lng,
        }}
        // onMapClick={onPlaceSelected}
        options={{
          styles: mapStyles,
          disableDefaultUI: true,
          fullscreenControl: false, //  removes fullscreen button
          streetViewControl: false, // optional: removes pegman
          mapTypeControl: false, // optional: removes map/satellite toggle
          zoomControl: false, // keep zoom buttons (or set false)
          scrollwheel: false,
          disableDoubleClickZoom: false,
          gestureHandling: "none",
        }}
      >
        <Marker
          draggable={false}
          // onDragEnd={onMarkerDragEnd}
          position={{
            lat: markerLocation.lat,
            lng: markerLocation.lng,
          }}
          icon={markerIcon}
        />
      </GoogleMapAny>
    ))
  );

  // if (!mapPosition.lat || !mapPosition.lng) {
  //   console.log("mapPosition", mapPosition)
  //   return <div>Loading map...</div>;
  // }

  return (
    <div style={{ height: '100%' }}>
      <MapWithMarker
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLEMAPS_API_KEY}&libraries=places`}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `100%` }} />}
        mapElement={<div style={{ height: `100%` }} />}
      />
    </div>
  );
};

export default React.memo(GoogleCustomMap);

// import React, { useState, useMemo } from "react";
// import { Map, Marker, APIProvider,
//   // InfoWindow,
// } from "@vis.gl/react-google-maps";
// import { useSelector } from "react-redux";
// import Konsole from "../../utils/konsole/Konsole";

// const GoogleCustomMap = (props: any) => {
//   const [isInfoWindowOpen, setIsInfoWindowOpen] = useState(false);
//   const storeInfo = useSelector((state: any) => state?.store?.selectedStore);

//   // Konsole.log('isInfoWindowOpen',props,isInfoWindowOpen)

//   // @@ return lang and lat
//   const latLong = useMemo(() => {
//     const lat = storeInfo?.lattitude || "50.8258231";
//     const lng = storeInfo?.longitude || "-1.214486";
//     const storeName = storeInfo?.store_name || "";
//     return { lat, lng, storeName };
//   }, [storeInfo]);

//   //Return marker cordinates
//   const markerLocation = useMemo(() => {
//     return {
//       lat: Number(latLong?.lat),
//       lng: Number(latLong?.lng)
//     }
//   }, [latLong])

//   return (
//     <APIProvider apiKey={process.env.REACT_APP_GOOGLEMAPS_API_KEY || ""}>
//       <div className="map-container pointer-events-none">
//         <Map
//           style={{ borderRadius: "15", width: "100%", height: "140px"}}
//           defaultZoom={17}
//           defaultCenter={markerLocation}
//           gestureHandling={"none"}
//           disableDefaultUI
//           draggable={false}
//           clickableIcons={false}
//         >
//           <Marker
//             position={markerLocation}
//             onClick={() => setIsInfoWindowOpen(true)} // Show info window when marker is clicked
//           />

//         </Map>
//       </div>
//     </APIProvider>
//   );
// };

// export default GoogleCustomMap;
